import React, { useRef } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDownloader from './chartDownloader';
import MDTypography from 'components/MDTypography';
import { CircularProgress } from '@mui/material';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        x: {
            grid: {
                display: false, // Removes grid from X-axis
            },
        },
        y: {
            grid: {
                display: false, // Removes grid from Y-axis
            },
        },
    },
    plugins: {
        legend: {
            position: 'bottom',
        },
        title: {
            display: false,
            text: 'Chart.js Bar Chart',
        },
    },
};

export default function BarChart({ data, label, loading }) {
    const chartRef = useRef(null);
    const empty = data?.labels.length > 0

    return (
        <div style={{ height: loading ? "300" : !empty ? '100px' : '300px' }}>
            <ChartDownloader download={empty} reff={chartRef} label={label} />
            {
                loading ? <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }} >
                    <CircularProgress />
                </div>
                    : empty ?
                        <Bar ref={chartRef} options={options} data={data} />
                        :
                        <MDTypography variant="h6" color="dark" style={{ marginTop: "5px" }}>
                            Sem dados no período seleccionado
                        </MDTypography>
            }
        </div>
    );
}
